import type { FaireProductEntity } from "../../entity_types/product";

export const p_28yzt2j49j: FaireProductEntity = {
  token: "p_28yzt2j49j",
  type: "product",
  name: "#046 Graduated Sterling Pearls",
  brandToken: "b_2uh94q39qp",
  brandName: "Z Bars Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/c10e5146384bd58bd795580bc0e55789193d9fa7b747b35cc223d35501077a13.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/029dda892f2a811ad424e88a904595e987081affaded21dbfa4dac931bab39f4.jpeg",
  ],
  priceDollars: 100,
  description:
    'Graduated Sterling Silver Pearl Necklace- A timeless classic with a modern edge, this necklace features hand-polished sterling silver pearls in a smooth graduated design—4mm, 5mm, 6mm, 8mm, and 10mm. Available in multiple lengths to suit any style, from a choker-like 16" to a dramatic 24". Perfect for layering or as a refined standalone piece.\n\nLengths Available: 16", 18", 20", 24"\n\nMaterials: Sterling silver machine made pearls\n\nPearl Sizes: Graduated 4mm, 5mm, 6mm, 8mm, 10mm\n\nFinish: Hand-polished \n\nStyle: Classic, versatile, elegant, layer, western, cowgirl\n',
  tags: [],
  msrpDollars: 200,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:00.990Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
